import React from 'react';
import { useNavigate } from 'react-router-dom';
import cns from 'classnames';
import pageData from '../../../common/local/data.json';
import styles from './index.module.less';
import { Button } from 'antd';

function TalentPC() {
  const navigate = useNavigate();

  const handleRegister = () => {
    navigate('/project/application');
    // window.open('http://azalea-tech.mikecrm.com/S8juig5');
  };

  const renderStation = () => (
    <div className={styles.station}>
      <div className={styles.subtitle}>{pageData.station.title}</div>
      <div className={styles.content}>{pageData.station.content1}</div>
      <div className={styles.content}>{pageData.station.content2}</div>
      <img src={pageData.station.imgList[0]} alt="" className={styles.station__img} />
      <div className={styles.content}>{pageData.station.content3}</div>
      <img src={pageData.station.imgList[1]} alt="" className={styles.station__img} />
      <div className={styles.content}>{pageData.station.content4}</div>
    </div>
  );

  const renderQintian = () => (
    <div className={styles.station}>
      <div className={styles.subtitle}>{pageData.qintian.title}</div>
      <div className={styles.content}>{pageData.qintian.content1}</div>
      <div className={styles.content}>{pageData.qintian.content2}</div>
      <img src={pageData.qintian.imgList[0]} alt="" className={styles.station__img} />
      <div className={styles.content}>{pageData.qintian.content3}</div>
      <img src={pageData.qintian.imgList[1]} alt="" className={styles.station__img} />
    </div>
  );

  return (
    <section className={styles.local}>
      <div className={styles.local__container}>
        {renderStation()}
        {renderQintian()}
      </div>
    </section>
  );
}

export default TalentPC;
